import React, { useState, useEffect,  useCallback } from 'react';
import {  Drawer} from 'antd';
import FilterSelect from "components/Form/filterSelect"
import {  useSelector } from 'react-redux';
import { genderOptions, maritalStatusOptions } from 'utils/constants';
import FilterDate from "components/Form/dateFilterInput"
import { Button } from 'components/Button';
import DateInput from 'components/Form/dateInput';


const AssetFilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange

}) => {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState('right');  
  

   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);


  const setInputValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        return selectedValue?.value
    }
    return ""

  }, [filters]);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const onChange = (e) => {
    setPlacement(e.target.value);
  };
  return (
    <>
      <Drawer
        title="Basic Drawer"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
      >
        <div className="col mb-3 d-flex justify-content-between">
          <h3 className="page-title">Filters</h3>
          <i onClick={handleFilterDrawer}  className='la la-close cursor-pointer ' />
        </div>
          

        <div className='col-12 mb-3' >
          <DateInput 
          selected={setFilterValue("issued_date_before")?.value}  
          onChange={e=>{handleDateChange(e.target.value, "issued_date_before")}} 
          id="search" 
          label={"Issued Before"} 
          />
        </div>

        <div className='col-12 mb-3' >
          <DateInput 
          selected={setFilterValue("issued_date_after")?.value}  
          onChange={e=>{handleDateChange(e.target.value, "issued_date_after")}} 
          id="search" 
          label={"Issued After"} 
          />
        </div>

        <div className='col-12 mb-3' >
          <DateInput 
          selected={setFilterValue("returned_date_before")?.value}  
          onChange={e=>{handleDateChange(e.target.value, "returned_date_before")}} 
          id="search" 
          label={"Returned Before"} 
          />
        </div>

        
        <div className='col-12 mb-3' >
          <DateInput 
          selected={setFilterValue("returned_date_after")?.value}  
          onChange={e=>{handleDateChange(e.target.value, "returned_date_after")}} 
          id="search" 
          label={"Returned After"} 
          />
        </div>


        <div className="col-12">
         <Button label="Search" loading={filterLoading} disabled={filterLoading} onClick={handleApplyFilter}   className="btn btn-primary  w-100"/>    
        </div>

      </Drawer>
    </>
  );
};
export default AssetFilterDrawer;